import { FC } from "react";

export const PreAccess: FC = () => {
  return (
    <main className="min-h-screen flex flex-col items-center mt-32 text-3xl main-button-color"></main>
  );
};
